exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filterColumns td{cursor:pointer;padding:10px 5px;border-right:1px solid #e7eaec}", ""]);

// exports
